import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';

import AddForm from './AddForm';
import DataTable from './DataTable';
import { useClientSupervisionEditable } from '../../../../../hooks';
import { clientSupervisionActions } from '../../../../../store';

import type { IClientSupervision, ITargetPhase } from '../../../../../utils/types';

interface DefineTargetPhaseChangeLineProps {
  clientSupervision: IClientSupervision | null;
}

function DefineTargetPhaseChangeLine(props: DefineTargetPhaseChangeLineProps) {
  const { clientSupervision } = props;
  const isEditable = useClientSupervisionEditable();
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [targetPhase, setTargetPhase] = useState<ITargetPhase[]>([]);

  useEffect(() => {
    if (!clientSupervision) {
      setTargetPhase([]);
      return;
    }

    setTargetPhase(clientSupervision.target_phase || []);
  }, [clientSupervision]);

  const handleAdd = (data: ITargetPhase) => {
    if (!data || !clientSupervision) return;

    dispatch(
      clientSupervisionActions.createTargetPhase({
        supervisionId: clientSupervision.id,
        data,
        getAccessTokenSilently,
      }),
    );
  };

  const handleDelete = (id: number) => {
    if (!id || !clientSupervision) return;

    dispatch(
      clientSupervisionActions.deleteTargetPhase({
        supervisionId: clientSupervision.id,
        targetPhaseId: id,
        getAccessTokenSilently,
      }),
    );
  };

  return (
    <Box>
      <AddForm onAdd={handleAdd} isEditable={isEditable} />
      {targetPhase.length > 0 && (
        <Box sx={{ mt: 3 }}>
          <DataTable data={targetPhase} onDelete={handleDelete} />
        </Box>
      )}
    </Box>
  );
}

export default DefineTargetPhaseChangeLine;
